import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import graphQLClientInstance from './axios-graphql-client';
import { getToken, isStandaloneVarietyDatasheet, getUrlParam, checkTokenError, API_URLS, NO_COOKIE_REDIRECT } from './shared/utility';

let langWhitelist = ["en"];
try {
  const languages = process.env.REACT_APP_LANGUAGES;
  if (languages) {
    langWhitelist = Object.keys(JSON.parse(languages));
  }
} catch { }

i18n
  // load translation using http -> see /public/locales
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  .use({
    type: 'languageDetector',
    async: true,
    init: function(services:any, detectorOptions:any, i18nextOptions:any) {
      /* use services and options */
    },
    detect: async function(callback:any) {
      let language = "en";

      if (isStandaloneVarietyDatasheet()) {
        const langURL = getUrlParam('lang');
        if (langURL && langWhitelist.includes(langURL)) {
          language = langURL;
        }
      } else {
        const sessionValue = getToken();
        if (sessionValue && !checkTokenError(sessionValue)) {
          await graphQLClientInstance.get(API_URLS.USER_SETTINGS).then(res => {
            const settings = res.data;
            window.sessionStorage.setItem('settings', JSON.stringify(settings));
            if ('i18nextLng' in settings) {
              language = settings.i18nextLng;
            }
          }).catch((err) => console.log(err));
        } else {
          sessionStorage.setItem(process.env.REACT_APP_COOKIE_KEY!, NO_COOKIE_REDIRECT)
        }
      }

      callback(language);
    },
    cacheUserLanguage: function(lng :any) {
      /* cache language */
    }
  })
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    detection: {
      // order: ['localStorage', 'navigator'],
      order: ['navigator'],
      caches: ['localStorage'],
      // only detect languages that are in the whitelist
      checkWhitelist: true,
      checkForSimilarInWhitelist: true
    },
    whitelist: langWhitelist,
    fallbackLng: 'en',
    // lng: "en",
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json'
    },
    debug: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;
